/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export type WaitlistPriority = 'low' | 'medium' | 'high';
export type WaitlistStatus = 'waiting' | 'contacted' | 'scheduled' | 'removed';

export interface WaitlistEntry {
  readonly id: string;
  readonly childName: string;
  readonly age: number | null;
  readonly concern: string | null;
  readonly preferredSlots: string | null;
  readonly contactPhone: string | null;
  readonly priority: WaitlistPriority;
  readonly status: WaitlistStatus;
  readonly notes: string | null;
  readonly waitSince: string;
  readonly createdAt: string;
}

export interface CreateWaitlistPayload {
  readonly childName: string;
  readonly age?: number;
  readonly concern?: string;
  readonly preferredSlots?: string;
  readonly contactPhone?: string;
  readonly priority?: WaitlistPriority;
  readonly notes?: string;
}

export interface UpdateWaitlistPayload {
  readonly status?: WaitlistStatus;
  readonly priority?: WaitlistPriority;
  readonly concern?: string;
  readonly preferredSlots?: string;
  readonly contactPhone?: string;
  readonly notes?: string;
}

const BASE = '/waitlist';

export const waitlistApi = {
  async list(status?: WaitlistStatus): Promise<readonly WaitlistEntry[]> {
    const { data } = await apiClient.get<readonly WaitlistEntry[]>(BASE, {
      params: status !== undefined ? { status } : {},
    });
    return data;
  },
  async create(payload: CreateWaitlistPayload): Promise<WaitlistEntry> {
    const { data } = await apiClient.post<WaitlistEntry>(BASE, payload);
    return data;
  },
  async update(id: string, payload: UpdateWaitlistPayload): Promise<WaitlistEntry> {
    const { data } = await apiClient.patch<WaitlistEntry>(`${BASE}/${id}`, payload);
    return data;
  },
};
